import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import logo from '../assets/logos/logo.png';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isServicesOpen, setIsServicesOpen] = useState(false);
    const location = useLocation();

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const navLinks = [
        { name: 'Accueil', path: '/' },
        { name: 'Qui Sommes-Nous ?', path: '/about' },
        { name: 'Nos Services', path: '/services', isDropdown: true },
        { name: 'Nos tarifs', path: '/tarifs' },
        { name: 'Nous Contacter', path: '/contact' },
        { name: 'Vos Avis', path: '/avis' },
    ];

    const serviceLinks = [
        { name: 'Transport PMR', path: '/services/pmr' },
        { name: 'Centres Spécialisés', path: '/services/specialise' },
        { name: 'Transport Conventionné', path: '/services/conventionne' },
        { name: 'Transferts Gares & Aéroports', path: '/services/aeroport' },
    ];

    return (
        <nav className="navbar" style={{
            backgroundColor: 'var(--secondary-color)',
            color: 'white',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
            boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
        }}>
            <div className="container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem' }}>
                <Link to="/" className="logo">
                    <img src={logo} alt="2ATP-MR" style={{ height: '50px' }} />
                </Link>

                {/* Desktop Menu */}
                <div className="desktop-menu" style={{ display: 'flex', gap: '2rem', alignItems: 'center' }}>
                    {navLinks.map((link) => {
                        if (link.isDropdown) {
                            return (
                                <div
                                    key={link.name}
                                    style={{ position: 'relative' }}
                                    onMouseEnter={() => setIsServicesOpen(true)}
                                    onMouseLeave={() => setIsServicesOpen(false)}
                                >
                                    <Link
                                        to={link.path}
                                        style={{
                                            fontWeight: 700,
                                            color: location.pathname.startsWith(link.path) ? 'var(--primary-color)' : 'white',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.25rem',
                                            padding: '0.5rem 0'
                                        }}
                                    >
                                        {link.name} <ChevronDown size={16} />
                                    </Link>

                                    {isServicesOpen && (
                                        <div style={{
                                            position: 'absolute',
                                            top: '100%',
                                            left: '50%',
                                            transform: 'translateX(-50%)',
                                            backgroundColor: 'var(--secondary-color)',
                                            minWidth: '220px',
                                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                                            borderRadius: '4px',
                                            padding: '0.5rem 0',
                                            zIndex: 1001
                                        }}>
                                            {serviceLinks.map((service) => (
                                                <Link
                                                    key={service.name}
                                                    to={service.path}
                                                    style={{
                                                        display: 'block',
                                                        padding: '0.75rem 1.5rem',
                                                        color: 'white',
                                                        fontWeight: 500,
                                                        fontSize: '0.95rem',
                                                        transition: 'background-color 0.2s'
                                                    }}
                                                    onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                                                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                                >
                                                    {service.name}
                                                </Link>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            );
                        }
                        return (
                            <Link
                                key={link.name}
                                to={link.path}
                                style={{
                                    fontWeight: 700,
                                    color: location.pathname === link.path ? 'var(--primary-color)' : 'white',
                                    position: 'relative'
                                }}
                            >
                                {link.name}
                            </Link>
                        );
                    })}
                </div>

                {/* Mobile Filter Button */}
                <button className="mobile-toggle" onClick={toggleMenu} style={{ display: 'none', background: 'none', border: 'none', cursor: 'pointer', color: 'white' }}>
                    {isOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </div>

            {/* Mobile Menu Styling */}
            <style>{`
        @media (max-width: 768px) {
          .desktop-menu { display: none !important; }
          .mobile-toggle { display: block !important; }
        }
      `}</style>

            {isOpen && (
                <div className="mobile-menu" style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    width: '100%',
                    backgroundColor: 'var(--secondary-color)',
                    padding: '2rem',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1.5rem',
                    textAlign: 'center'
                }}>
                    {navLinks.map((link) => (
                        <div key={link.name}>
                            <Link
                                to={link.path}
                                onClick={() => setIsOpen(false)}
                                style={{ fontWeight: 700, fontSize: '1.1rem', color: 'white' }}
                            >
                                {link.name}
                            </Link>
                            {/* Simple mobile indication for services, could be expanded later */}
                            {link.isDropdown && (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginTop: '0.5rem' }}>
                                    {serviceLinks.map(s => (
                                        <Link key={s.name} to={s.path} onClick={() => setIsOpen(false)} style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem' }}>{s.name}</Link>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </nav>
    );
};

export default Navbar;
